// removed by extract-text-webpack-plugin
module.exports = {"locationButton":"VnPtjh_OH91781Vx9qBvp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CurrentLocation/CurrentLocation.scss
// module id = 1571
// module chunks = 0